<template>
  <div class="address-picker">
    <div class="picker" @click="showPicker">
      <div class="placeholder" v-if="!addressData.address_id"><icon icon-class="plus"></icon>添加收货地址</div>
      <div class="picked-address" v-else>
        <div class="address-info">
          <div class="name">{{addressData.name}}<span>{{addressData.mobile}}</span></div>
          <div class="edit" v-show="!readOnly">修改</div>
        </div>
        <div class="address">{{addressData.address}}</div>
      </div>
    </div>
    <van-popup v-model="addressPickerShow" position="bottom" :style="{height: '100%'}">
      <div class="popup-wrapper">
        <div class="popup-header">
          地址管理
          <span class="close-popup" @click="addressPickerShow = false">取消</span>
        </div>
        <div class="address-wrapper">
          <div class="address-list">
            <div class="address-item" :class="{'selected': item.address_id === addressData.address_id}" v-for="item in addressList" @click="chooseAddress(item)">
              <div class="item-head">
                <div class="item-title">{{item.name}}<span>{{item.mobile}}</span></div>
                <div class="edit" @click.stop="editAddress(item)">编辑</div>
              </div>
              <div class="address-card-content">{{item.address}}</div>
            </div>
          </div>
        </div>
        <div class="add-new-address"><button class="add-button" @click="addNewAddress">新增收货地址</button></div>
      </div>
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .address-picker{
    margin-top: 12px;
    background: #FFF;
    height: 72px;
    border-radius: 6px;
    .picker{
      width: 100%;
      height: 100%;
      .placeholder{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 30px;
        font-size: 14px;
        line-height: 14px;
        color: #666;
        svg{
          font-size: 12px;
          margin-right: 8px;
          color: #666;
        }
      }
      .picked-address{
        height: 100%;
        padding: 0 12px 0 16px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        .address-info{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .name{
            font-size: 16px;
            line-height: 16px;
            color: @black;
            font-weight: bold;
            span{
              margin-left: 8px;
            }
          }
          .edit{
            font-size: 14px;
            line-height: 14px;
            color: #666;
            font-weight: normal;
          }
        }
        .address{
          margin-top: 10px;
          font-size: 14px;
          line-height: 16px;
          color: #666;
          max-width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
    // 弹窗
    .popup-wrapper{
      position: relative;
      width: 100%;
      height: 100%;
      background: #FFF;
      .popup-header{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 15px;
        font-weight: bold;
        background: #F3F3F3;
        z-index: 100;
        .close-popup{
          position: absolute;
          top: 50%;
          right: 16px;
          transform: translateY(-50%);
          font-size: 13px;
          color: @black;
          font-weight: normal;
          background: transparent;
          border: 0;
        }
      }
      .address-wrapper{
        padding-top: 48px;
        padding-bottom: 64px;
        height: calc(100%);
        background: #FAFAFA;
        overflow-y: auto;
        -webkit-overflow-scroll: touch;
        .address-list{
          padding: 0 16px 16px;
          .address-item{
            margin-top: 12px;
            width: 100%;
            border-radius: 6px;
            overflow-y: hidden;
            box-shadow: 0px 2px 10px 0px rgba(51,51,51,0.08);
            border: 1px solid transparent;
            background: #FFF;
            &.selected{
              border-color: @xile;
            }
            .item-head{
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 48px;
              border-bottom: 1px solid #F3F3F3;
              padding: 0 0 0 16px;
              background: #FAFAFA;
              .item-title{
                position: relative;
                padding-left: 19px;
                font-size: 16px;
                line-height: 16px;
                font-weight: bold;
                color: @black;
                &::after{
                  content: '';
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 4px;
                  height: 16px;
                  background: @xile;
                  border-radius: 2px;
                }
                span{
                  margin-left: 8px;
                }
              }
              .edit{
                font-size: 14px;
                height: 100%;
                padding: 0 20px;
                color: #666;
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
            .address-card-content{
              padding: 20px;
              font-size: 14px;
              line-height: 24px;
              color: #666;
            }
          }
        }
      }
      .add-new-address{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 12px 16px;
        background: #FAFAFA;
        .add-button{
          @button-base();
          width: 100%;
          height: 40px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      addressData: {
        type: Object,
        default: () => {
          return {
            address_id: null,
            name: '',
            mobile: '',
            province: '',
            city: '',
            country: '',
            region: '',
            address: '',
          }
        }
      },
      readOnly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        addressPickerShow: false,
        addressList: [],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      console.log(this.addressData)
    },
    methods: {
      showPicker() {
        if(this.readOnly) return;
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner',
          message: '加载中'
        });
        this.$root.post('/getAddressList', {
          user_id: this.userInfo.user_id
        }).then(data => {
          console.log(data)
          this.$toast.clear();
          this.addressList = data || [];
          this.addressPickerShow = true;
        })

      },
      chooseAddress(item) {
        this.addressPickerShow = false;
        this.$emit('picked', item);
      },
      editAddress(item) {
        this.$router.push({path: '/patient/address/edit', query: {address_id: item.address_id}});
      },
      addNewAddress() {
        this.$router.push({path: '/patient/address/edit'});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/addressPicker.vue